module.exports = __webpack_public_path__ + "static/media/advasonic-2.2ddb9795.png";